import carouselImage1 from '../images/slider/slider1.jpeg'
import carouselImage2 from '../images/slider/slider2.jpeg'
import carouselImage3 from '../images/slider/slider3.jpeg'
import carouselImage4 from '../images/slider/slider4.jpeg'
import carouselImage5 from '../images/slider/slider5.jpeg'
import carouselImage6 from '../images/slider/slider6.jpeg'
import carouselImage7 from '../images/slider/slider7.png'
import carouselImage8 from '../images/slider/slider8.jpeg'

const mainBannerData=[{
    image: carouselImage1
},
{
    image: carouselImage2
},
{
    image: carouselImage3
},
{
    image: carouselImage4
},
{
    image: carouselImage5
},
{
    image: carouselImage6
},
{
    image: carouselImage7
},
{
    image: carouselImage8
}]
export default mainBannerData